import React from "react"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import parse from "html-react-parser"
import StatisticsCardsShort from "../../StatisticsCardsShort.jsx"
import PlatformsAvailable from "../../PlatformsAvailable.jsx"

const HeaderSectionLeft = ({ data }) => {
  // Handle missing or invalid data
  if (!data) return null
  
  // Safe parsing function
  const safeParse = (content) => {
    if (!content || typeof content !== 'string' || content.trim() === '') {
      return content || ''
    }
    try {
      return parse(content)
    } catch (error) {
      console.warn('Failed to parse HTML content:', error)
      return content
    }
  }
  
  const title = data?.title ?? ""
  const description = data?.description ?? ""
  const menu = data?.menu ?? []
  
  return (
    <div className="flex flex-col w-full md:w-[55%] lg:w-[60%] xl:w-[50%] justify-start items-start">
      <div className="flex flex-col w-full max-w-[800px] items-center md:items-start md:pt-[50px] xl:pt-[85px]">
        {/* Title */}
        <Typography
          component="h1"
          variant="title2"
          className="w-full max-w-[410px] md:max-w-full text-center md:text-left mb-4 md:mb-[25px]"
        >
          {safeParse(title)}
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="subtitle_signature"
          className="w-full max-w-[300px] md:max-w-[400px] lg:max-w-full text-center md:text-left mb-6 md:mb-10 lg:mb-[56px]"
        >
          {safeParse(description)}
        </Typography>

        {/* CTA Buttons and Statistics */}
        <div className="flex flex-col-reverse md:flex-col items-center md:items-start">
          {/* CTA Buttons and Platforms */}
          <div className="flex flex-col items-center md:items-start">
            {menu.map((item, index) => {
              const variant = index === 0 ? "primary_alt_xl" : "secondary_xl"
              const url = item?.link && item?.link[0]?.url
              return (
                <Button 
                  key={index} 
                  variant={variant}
                >
                  <a href={url}>
                    {item?.label ?? ""}
                  </a>
                </Button>
              )
            })}

            <div className="mt-6 md:mb-8">
              <PlatformsAvailable data={data}/>
            </div>
          </div>

          {/* Statistics Cards - Android Only */}
          <div className="mb-8 md:mb-0 md:mt-3 lg:mt-2 xl:mt-0">
            <StatisticsCardsShort />
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderSectionLeft
